import { AfterViewInit, ContentChild, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[tiAddTextPagination]',
})
export class AddTextPaginationDirective implements AfterViewInit {
  @Input('tiAddTextPagination') config;
  @ContentChild('kendoPagerSignature') kendoPagerSignature: ElementRef;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    const signature = this.kendoPagerSignature.nativeElement;
    let link: HTMLElement;

    switch (this.config.position) {
      case 'left':
        link = this.el.nativeElement.children[0];
        link.insertBefore(signature, link.firstChild);
        break;
      case 'right':
        link = this.el.nativeElement.children[1];
        link.appendChild(signature);
        break;
    }
  }
}
